<template>
    <div>
        <el-card shadow = "never">
            <el-row>
                <el-col :span="23" :offset="1">
                    <el-form
                        :model="ruleForm" 
                        :rules="rules" 
                        ref="ruleForm"
                        label-width="80px"
                        class="demo-ruleForm"
                    >
                        <el-form-item label="销售地点" prop="locationCode">
                            <el-select v-model="value" filterable placeholder="试一试搜索:销售地点" :clearable = 'clearable' @change="handleChange2" size = "large" style="width : 350px" :disabled = "disabled">
                                <i class="el-icon-loading" slot = "prefix" v-if='isLoading'></i>
                                <el-option
                                    v-for="item in options2"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label ="日期" prop="date">
                            <el-date-picker
                                v-model="ruleForm.date"
                                type="daterange"
                                range-separator="至"
                                placeholder="选择日期"
                                value-format = "yyyy-MM-dd"
                                format="yyyy-MM-dd"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                :default-value = "defaultVal"
                                >
                            </el-date-picker>
                            <p class="tip"><span>*</span>{{dateNullTip}}</p>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="submitForm('ruleForm')">确认</el-button>
                            <el-button @click="cancel">返回</el-button>
                            <el-button @click="downLoad2('销售详情')" type="success">下载表格</el-button>
                            
                        </el-form-item>
                    </el-form>
                </el-col>
            </el-row>
            <el-row>
                <!-- <el-col :span="6" style="float:right;margin-bottom:20px;">
                    <el-input placeholder="请输入券号搜索" v-model="input5" class="input-with-select" clearable prefix-icon="el-icon-search">
                    </el-input>
                </el-col> -->
                
                <el-col :span="24">
                    <el-table
                        max-height="340"
                        :data = "tableData"
                        :summary-method="getSummaries"  
                        show-summary
                        border
                        style="width:100%"
                        v-loading="loading"
                    >
                        <!-- <el-table-column
                            prop="salesDate"
                            label="日期"
                            
                            align="left"
                            header-align="center"
                            >
                        </el-table-column> -->
                        <el-table-column
                            prop="addr"
                            label="地点"
                            header-align="center"
                            align="left"
                            >
                        </el-table-column>
                        <el-table-column
                            prop="totalAmounnt"
                            label="券数量"
                            width="80"
                            header-align="center"
                            align="right"
                            >
                        </el-table-column>
                        <el-table-column
                            prop="totalCount"
                            label="订单数量"
                            width="80"
                            header-align="center"
                            align="right"
                            >
                        </el-table-column>
                        <el-table-column
                            prop="totalPrice"
                            label="金额"
                            width="100"
                            header-align="center"
                            align="right"
                            >
                        </el-table-column>
                    </el-table>
                </el-col>
            </el-row>
        </el-card>
    </div>
</template>
<style lang="less" scoped>
@import '~@/assets/css/common';
</style>
<script>
import requestMixin from '../../mixins/request'
import common from '../../mixins/common'
import axios from '../../env/axios'
import apis from '../../env/apis'
export default {
    mixins:[requestMixin,common],
    data(){
        return {
            ruleForm:{
                locationCode:'',
                date : ''
            },
            defaultVal :[],
            rules:{
                locationCode: [
                    { required: true, message: '请填写地点名称', trigger: 'blur' },
                ], 
            },
            options2:[],
            value: '',
            tableData:[],
            clearable : false,
            disabled : true ,
            isLoading:true,
            input5:'',
            loading:false
        }
    },
    created (){},
    mounted(){
        this.loadingArea().then((res) => {
            this.options2 = res ;
            this.getLoc()
        }); 
        this.defaultNow();
    },
    methods:{
        submitForm(formName){
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let { locationCode, date } = this.ruleForm ;
                    let userId = sessionStorage.getItem("userId") ;
                    let params ;
                    this.tableData = [] ;
                    if(date == null && locationCode == '' || date == '' && locationCode == ''){
                        params = {
                            act : "orderByAddr",
                            from : '2000-01-01',
                            to : '3000-01-01',
                            userId
                        }
                    }else if(date == null && locationCode || date == '' && locationCode){
                        params = {
                            act : "orderByAddr",
                            from : '2000-01-01',
                            to : '3000-01-01',
                            location:locationCode,
                            userId
                        }
                    }else if(date && locationCode == ''){
                        params = {
                            act : "orderByAddr",
                            from : date[0],
                            to : date[1],
                            userId
                        }
                    }else{
                        params = {
                            act : "orderByAddr",
                            from : date[0],
                            to : date[1],
                            location:locationCode,
                            userId
                        }
                    }
                    this.getReports( params );
                } else {
                    return false;
                }
            });
        },
        //点击取消，跳转到上一页
        cancel(){
            this.$router.go(-1)
        },
        handleChange2(value){
            this.ruleForm.locationCode = value ;
            this.tableData = [];
        },
        /**
         * @description 默认显示用户地点code
        */
        getLoc(){
            this.getUserLocation().then((res) => {
                let userId = sessionStorage.getItem("userId") ;
                this.value = res ;
                if(this.options2.length > 0){
                    this.ruleForm.locationCode = res;
                    this.isTrueAccount(userId);
                    this.isLoading = false ;
                }
            })
        },
        /**
         * @description 财务账号-管理员A 查看所有地点
        */
        isTrueAccount(userId){
            let userLevel = sessionStorage.getItem("userLevel") ;
            if(userId == "SHFD01" || userId == "HBFD01" || userId == 'HNFD01' || userId == 'JENNIE' || userId == 'SYSADMIN'|| userLevel == 'A'){
                this.clearable = true ;
                this.disabled = false ;
            }else{
                // console.log('不是财务账号')
                this.clearable = false ;
                this.disabled = true ;
            }

        },
        /**
         * @description 请求结算报表
         * @param { Object } params
         */
        getReports(params){
            //加载中
            this.loading = true;
            this.delType(params).then((res) =>{
                let {code,data} = res.data;
                if(code == 200){
                    this.loading = false;
                    data.salesDate = `${params.from}至${params.to}`
                    this.tableData = [data];
                }else{
                    this.alert('查找失败!','warning')
                }
            })
        },
        //总计最后一行
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '总计';
                    return;
                }
                const values = data.map(item => Number(item[column.property].replace(/,/g, "")));
                if (!values.every(value => isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0);
                    sums[index] = this.changeTree(sums[index]);
                } else {
                    sums[index] = '';
                }
                });
                return sums;
        },
        //下载表格
        downLoad2(name){
            this.isDownTable(this.tableData, this.downLoad ,name);
        },
        defaultNow(){
            let defaultVal = this.defaultVal ;
            defaultVal[0] = new Date() ;
            defaultVal[0] = defaultVal[0].getFullYear() + '-' + this.checkTime(defaultVal[0].getMonth() + 1) + '-' + this.checkTime(defaultVal[0].getDate()) ;
            defaultVal[1] = defaultVal[0] ;
            this.ruleForm.date = defaultVal ;
        }
    }
}
</script>
